export default __webpack_public_path__ + "static/media/BlueLeftArrow.bb89ec71.svg";